import classNames from 'classnames';
import { useEffect, useRef, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { config } from '../../../utils/config';
import Button from '../Button';
import Input, { InputProps } from '../Input';
import './style.scss';

type IconAndButtonProps = {
  icon?: { src: string; alt?: string };
  button?: { text: string; onClick: () => void; disabled?: boolean; dataTestId?: string };
  isLoading?: boolean;
  optional?: boolean;
};

export type InputWithIconAndButtonProps = IconAndButtonProps & InputProps;

const InputWithIconAndButton = (props: InputWithIconAndButtonProps) => {
  const { icon, button, className, isLoading, inputref, optional, ...rest } = props;
  const [buttonWidth, setButtonWidth] = useState<number | undefined>(undefined);

  const localInputRef = useRef<HTMLInputElement>(null);
  const finalInputRef = inputref ?? localInputRef;

  const focusInputField = () => finalInputRef.current?.focus();

  const shouldSubmitOnClick = optional || rest.value;

  const buttonRef = useRef<HTMLButtonElement | null>(null);

  useEffect(() => {
    if (buttonRef.current) {
      setButtonWidth(buttonRef.current.clientWidth + 16);
    }
  }, []);

  const isrtl = ['ar', 'he'].includes(config.locale.substring(0, 2));
  return (
    <div className={classNames(className, 'custom__input', { 'custom__input--icon': icon })}>
      {icon && <img className="custom__input-icon" src={icon.src} alt={icon?.alt ?? 'icon'} />}
      <Input
        {...rest}
        inputref={finalInputRef}
        className="custom__input"
        style={isrtl ? { paddingLeft: buttonWidth } : { paddingRight: buttonWidth }}
      />
      {button && (
        <Button
          ref={buttonRef}
          type="button"
          className="custom__input-btn"
          onClick={shouldSubmitOnClick ? button.onClick : focusInputField}
          isLoading={isLoading}
          disabled={button.disabled}
          data-test-id={button.dataTestId}
        >
          <FormattedMessage id={button.text} />
        </Button>
      )}
    </div>
  );
};

export default InputWithIconAndButton;
